"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPath = exports.getFallbackApiUrl = exports.getCmsApiUrl = void 0;
var userPreferredLocale_1 = require("./userPreferredLocale");
var checkPathForLocale = function (pathname) {
    var returnVal = false;
    userPreferredLocale_1.defaultLocales.forEach(function (loc) {
        var language = loc.substring(0, 2);
        if (pathname.indexOf("/" + language + "/") !== -1) {
            returnVal = true;
        }
    });
    return returnVal;
};
var getCmsApiUrl = function (language, path, revisionId, apiUrl, pageReplacer) {
    if (apiUrl === void 0) { apiUrl = ''; }
    if (pageReplacer === void 0) { pageReplacer = ''; }
    var pathname = path;
    if (pathname.indexOf('/preview/') !== -1 ||
        pathname.indexOf('/preview-app/') !== -1 ||
        checkPathForLocale(pathname)) {
        // eslint-disable-next-line no-param-reassign
        apiUrl = (apiUrl === null || apiUrl === void 0 ? void 0 : apiUrl.replace('<localeApi>', '')) || '';
        // avoid double slashes due trailing slash in pathname
        pathname = pathname.replace(/^\/+/, '');
    }
    else {
        // eslint-disable-next-line no-param-reassign
        apiUrl = (apiUrl === null || apiUrl === void 0 ? void 0 : apiUrl.replace('<localeApi>', language)) || '';
    }
    return "" + apiUrl
        .replace(pageReplacer, pathname)
        .replace('/preview/', '/')
        .replace('/preview-app/', '/') + (revisionId ? "&revisionId=" + revisionId : '');
};
exports.getCmsApiUrl = getCmsApiUrl;
var getFallbackApiUrl = function (language, path, apiFallbackUrlProp, pageReplacer) {
    if (apiFallbackUrlProp === void 0) { apiFallbackUrlProp = ''; }
    if (pageReplacer === void 0) { pageReplacer = ''; }
    var pathname = path;
    var apiFallbackUrl = (apiFallbackUrlProp === null || apiFallbackUrlProp === void 0 ? void 0 : apiFallbackUrlProp.replace('<localeApi>', language)) || '';
    if (pathname.indexOf(language) === 1) {
        apiFallbackUrl = (apiFallbackUrlProp === null || apiFallbackUrlProp === void 0 ? void 0 : apiFallbackUrlProp.replace('<localeApi>', '')) || '';
        // avoid double slashes due trailing slash in pathname
        pathname = pathname.replace(/^\/+/, '');
    }
    var returnVal = apiFallbackUrl
        ? apiFallbackUrl.replace(pageReplacer, pathname
            .replace('/preview/', '/')
            .replace('/preview-app/', '/')
            .replace(/\/$/, '')
            .replace(/\//g, '_'))
        : null;
    return returnVal;
};
exports.getFallbackApiUrl = getFallbackApiUrl;
var getPath = function (location, localesToSwitch) {
    var pathname = (location && location.pathname) || '';
    var locales = userPreferredLocale_1.getTenantSpecificLocales(localesToSwitch);
    var lastLoc = '';
    if (location) {
        locales.forEach(function (loc) {
            if (lastLoc !== loc && location) {
                var language = loc.substring(0, 2);
                if (location.pathname === "/" + language || location.pathname === "/" + language + "/") {
                    pathname = "/" + language + "/storefront";
                }
                lastLoc = loc;
            }
        });
    }
    if (location && location.pathname === '/') {
        pathname = '/storefront';
    }
    return pathname;
};
exports.getPath = getPath;
//# sourceMappingURL=apiUrl.js.map